import { render, staticRenderFns } from "./DashboardOverviewNumberOfThisWeekOrdersTile.vue?vue&type=template&id=2432804e"
import script from "./DashboardOverviewNumberOfThisWeekOrdersTile.vue?vue&type=script&lang=js"
export * from "./DashboardOverviewNumberOfThisWeekOrdersTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports